require('./strokeWidthDD.less');

var DropDown = require('../../../../../../common/dropDown/dropDownWr.js');


module.exports = DropDown.extend({
    template: require('./strokeWidthDD'),
    onChange: function(text, data) { //note: no text
        this.options.channel.trigger('strokeView:setWidth', data.sw);
    },
    defaultSelector: function() {
        return '[data-sw="' + this.ddOptions.defaultWidth + '"]';
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/header/shapeDrawingToolbars/graphicNoteTB/strokeWidthSelector/strokeWidthSelector.js
 ** module id = 512
 ** module chunks = 0
 **/